<template>
  <div class="importModel" @click="mentNoImport">
      <div class="modelInfoBox">
          <div class="importModelHead">
              <div class="settingPrice">
                  <div>
                      <span>默认会员价：<input type="number" v-model="vip_price"></span>
                  </div>
                  <div>
                      <span>零售价：<input type="number" v-model="price"></span>
                  </div>
              </div>
              <div class="importModelBtn" @click="importModelFun">导入模型</div>
              <div @click="noImport" class="noImport"><i class="el-icon-close"></i></div>
          </div>
          <div class="content">
              <div class="modelClassList">
                  <div @click="changeClass(item.id)" v-for="item in classList" :class="nowClassId == item.id?'active':''" :title="item.name" :key="item.id">
                      {{item.name}}
                  </div>
              </div>
              <div class="modelListBox">
                  <div class="modelList">
                      <div v-for="item in list" :key="item.id" @click="chooseModel(item.id)" :class="isChecked(item.id)?'isChecked':''">
                          <div class="modelImg">
                              <img :src="item.img_url" alt="">
                          </div>
                          <div class="name_views">
                              <span>{{item.model_name}}</span>
                              <span><img src="../../../../assets/view.png" alt="">{{item.views}}</span>
                          </div>
                          <div v-show="isChecked(item.id)" class="isCheckedGou"><img src="../../../../assets/gougou.png" alt=""></div>
                      </div>
                  </div>
                  <div class="footChoose">
                      <el-checkbox v-if="list.length" v-model="checkAll" @change="checkAllModel">全选</el-checkbox>
                      <div class="pageBox">
                        <div @click="getMore(0)" v-if="form.page > 1">上一页</div>
                        <div @click="getMore(1)" v-if="(totalPage - form.page) > 0">下一页</div>
                    </div>
                  </div>
                  
              </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            nowClassId:0,
            classList:[
                {
                    name:'所有',
                    id:0,
                    count:0
                }
            ],
            list:[],
            form:{
                page:1,
                uid:this.$store.state.userInfo.id,
                limit:12
            },
            checkedIds:[],
            checkAll:false,
            totalPage:0,
            vip_price:'',
            price:''
        }
    },
    methods:{
        checkAllModel(value){
            if(value){
                this.list.forEach(item => {
                    this.checkedIds.push(item.id)
                })
            }else{
                this.checkedIds = []
            }
        }, 
        getMore(value){
            if(value){
                ++this.form.page
                console.log(this.form.page)
                this.getModelList()
            }else{
                --this.form.page
                this.getModelList()
            }
        },
        getModelList(){
            let form = this.form
            if(this.nowClassId){
                form.catelog_id = this.nowClassId
            }else{
                delete form.catelog_id
            }
            this.$post('/guigui/product/my_model',{
              data:JSON.stringify(form)  
            },res => {
                console.log(res.data.list)
                if(res.data.list){
                    this.list = res.data.list
                }
                this.totalPage = res.data.totalPage
            })
        },
        getClassList(){
            this.$get(`/guigui/product/catelog_tag_list/${this.userInfo.id}`,{},res => {
                console.log(res.data.sort_list)
                if(res.data.sort_list){
                    this.classList = this.classList.concat(res.data.sort_list)
                }
            })
        },
        importModelFun(){
            if(!this.checkedIds.length){
                this.$message({
                    message: '请选择模型',
                    type: 'warning',
                    duration:1000
                })
                return
            }
            if(this.vip_price && this.price){
                // 暂时设置价格为0也允许添加，只是价格必填，万一用户想填写价格0
                let payload = {
                    uid:this.userInfo.id,
                    supplier_id:this.supplier_id,
                    model_ids:this.checkedIds,
                    price:Number(this.price),
                    vip_price:Number(this.vip_price)
                }
                this.$message('即将上线')
                return
                this.$post('/py/erp/copy_model_info',payload, res => {
                    if(res.status == 1){
                       this.$message({
                           message:'导入成功',
                           type:'success',
                           duration:1000
                       })
                    }
                })
            }else{
                this.$message({
                    message: '请填写价格',
                    type: 'warning',
                    duration:1000
                })
            }
            // this.$emit('closeImport')
        },
        changeClass(id){
            this.nowClassId = id
            this.checkedIds = []
            this.form.page = 1
            this.checkAll = false
            this.getModelList()
        },
        chooseModel(id){
            if(this.checkedIds.indexOf(id) == -1){
                this.checkedIds.push(id)
            }else{
                this.checkedIds.forEach((item,index) => {
                    if(item == id){
                        this.checkedIds.splice(index,1)
                    }
                })
            }
            
        },
        noImport(){
            this.$emit('closeImport')
        },
        mentNoImport(event){
            let event1 = event.currentTarget
            let event2 = event.target
            if(event1 == event2){
                this.$emit('closeImport')
            }
        }
    },
    mounted(){
        this.getClassList()
        this.getModelList()
    },
    computed:{
        supplier_id(){
          if(this.$store.state.supplierInfo){
            return this.$store.state.supplierInfo.id
          }else{
            return 0
          }
        },
        isChecked(){
            return (id) => {
                if(this.checkedIds.indexOf(id) != -1){
                    return true
                }else{
                    return false
                }
            }
        },
        userInfo(){
            return this.$store.state.userInfo
        }
    }
}
</script>

<style lang='less'>
    .importModel{
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background-color: rgba(75, 75, 75, 0.3);
        text-align: left;
        .modelInfoBox{
            width: 1000px;
            // height: 800px;
            background-color: #efefef;
            position: relative;
            margin: 0 auto;
            top: 50%;
            transform: translateY(-50%);
            // padding: 10px 20px;
            box-sizing: border-box;
            .importModelHead{
                width: 100%;
                display: flex;
                align-items: center;
                background-color: #fff;
                padding: 10px 20px;
                position: relative;
                .noImport{
                    position: absolute;
                    right: 10px;
                    top: 4px;
                    cursor: pointer;
                    font-size: 20px;
                    color: #000;
                }
                .settingPrice{
                    display: flex;
                    >div{
                        margin-right: 30px;
                        input{
                            border: 1px solid #dedede;
                            outline: none;
                            height: 30px;
                            line-height: 30px;
                            padding-left: 4px;
                        }
                    }
                }
                .importModelBtn{
                    background: linear-gradient(131deg, #87B3FF 0%, #6376F7 100%);
                    color: #fff;
                    height: 30px;
                    line-height: 30px;
                    cursor: pointer;
                    border-radius: 4px;
                    padding: 0 10px;
                    &:hover{
                        background: #6376F7;
                    }
                }
            }
            .content{
                display: flex;
                margin-top: 20px;
                >div{
                    background-color: #fff;
                }
                .modelClassList{
                    width: 200px;
                    max-height: 697px;
                    overflow-y: auto;
                    border-radius: 0 6px 6px 0;
                    text-align: center;
                    >div{
                        cursor: pointer;
                        padding: 10px 20px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        &:hover{
                            background-color: #ddd;
                        }
                        &.active{
                            color: #6376F7;
                        }
                    }
                }
                .modelListBox{
                    padding: 10px;
                    width: 100%;
                    margin-left: 30px;
                    border-radius: 6px 0 0 6px;
                    .modelList{
                        display: flex;
                        flex-wrap: wrap;
                        >div{
                            cursor: pointer;
                            width: 22%;
                            margin:  0 4% 14px 0;
                            position: relative;
                            padding: 10px 10px 0;
                            background-color: #fbfbfb;
                            border: 1px solid #fff;
                            &:nth-of-type(4n){
                                margin: 0 0 14px 0;
                            }
                            &:hover{
                                box-shadow: 0 3px 6px rgba(86,86,86,.26);
                            }
                            &.isChecked{
                                border: 1px solid #6376F7;
                            }
                            .modelImg{
                                >img{
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                            .name_views{
                                padding: 4px 0;
                                display: flex;
                                justify-content: space-between;
                            }
                            .isCheckedGou{
                                position: absolute;
                                right: 0;
                                top: 0;
                                width: 20px;
                                height: 20px;
                                background-color: #6376F7;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                img{
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                        }
                    }
                    .footChoose{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        .pageBox{
                            display: flex;
                            justify-content: flex-end;
                            margin-top: 10px;
                            align-items: center;
                            >div{
                                padding: 4px 10px;
                                margin-left: 20px;
                                border-radius: 4px;
                                border: 1px solid #ddd;
                                cursor: pointer;
                                &:hover{
                                    border:1px solid #6376F7;
                                }
                            }
                        }
                    }
                }
            }
        }

    }
</style>